import * as React from "react";
import styled from "styled-components";
import Sidebar from "./components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { getChatHistory } from "../../../actions/chatsAction";
import Main from "./components/Main";
import Info from "./components/Info";
import { getGroups } from "../../../actions/groupsAction";
import { getAgents } from "../../../actions/agentsAction";
import ChatConversation from "../ChatConversation";

export interface IHistoryComponentProps {
  chats: any[];
}

const Container = styled.div`
  display: flex;
  height: calc(100vh - 58px - 58px);
`;

export const SelectedChatHistoryMessageContext = React.createContext({
  selectedChat: "",
  setSelectedChat: (arg: any) => { },
});

export default function HistoryComponent(props: IHistoryComponentProps) {
  const clientConversation = useSelector((state: any) => state.ui.clientConversation);
  const [selectedChat, setSelectedChat] = React.useState("");
  const dispatch = useDispatch();
  const fetchGroups = React.useCallback(() => dispatch(getGroups()), [
    dispatch,
  ]);
  const fetchAgents = React.useCallback(() => dispatch(getAgents()), [
    dispatch,
  ]);
  React.useEffect(() => {
    fetchGroups();
    fetchAgents();
  }, []);

  return (
    <Container>
      <SelectedChatHistoryMessageContext.Provider
        value={{ selectedChat, setSelectedChat }}
      >
        <Sidebar />
        <Main />
        <ChatConversation clientConversation={clientConversation} />
        <Info clientConversation={clientConversation} />
      </SelectedChatHistoryMessageContext.Provider>
    </Container>
  );
}
